import styled, { css } from 'styled-components';
import Link from 'gatsby-link';

import { SCREEN } from '../../../assets/styles/constants';

// Atoms
import { flex } from '../../../assets/styles/flex-grid';

export const LogoLink = styled(Link)`
	font-size: 40px;
	font-weight: bold;
`;

export const HeaderWrapper = styled.div`
	${flex};
	width: 100%;
	position: ${props => (props.isSticky ? 'sticky' : 'absolute')};
	top: 0px;
	height: 80px;
	z-index: 99999;
	box-shadow: 0px 6px 7px -5px rgba(204, 204, 204, 0.5);
	padding: 0px 100px;
	${props => (props.scrolled ?
		(css`
			background: white;
			box-shadow: 0px 6px 7px -5px rgba(204, 204, 204, 0.5);
			`) :
		(css`
			background: transparent;
			box-shadow: unset;
		`)
	)};
	
	${SCREEN.LARGE} {
		padding: 15px 15px;
	}
`;

export const HeaderMenuLimitingWidthWrapper = styled.div`
	${flex};
	max-width: 1920px;
	width: 100%;
	margin: auto;
	justify-content: space-between;
	align-items: center;
	${SCREEN.SMALL} {
		padding: 0;
	}
`;

export const HeaderLogo = styled.img`
	display: block;
	width: 100%;
	max-width: 180px;
	${SCREEN.SMALL} {
		max-width: 90px;
	}
	${SCREEN.MEDIUM} {
		max-width: 110px;
	}
	${SCREEN.LARGE} {
		max-width: 130px;
	}
`;
